import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IChipProps {
  theme: any;
}

const ChipBase = styled.span<IChipProps>`
  display: inline-block;
  color: ${({ theme }) => theme.color['primary-100']};
  white-space: nowrap;
  ${({ theme }) => theme.chipStyle};
  ${({ theme }) => theme.media.fold`
    padding: ${rem(4)} ${rem(6)} ${rem(5)};
    font-size: ${rem(10)};
  `};
`;

export const Chip = styled(ChipBase)<IChipProps>`
  background: ${({ theme }) => theme.color['primary-50']};
`;

export const ChipOutline = styled(ChipBase)<IChipProps>`
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color['primary-100']};
`;
